import React from 'react';
import classNames from 'classnames';
import { Button } from 'ncoded-component-library';
import XIcon from 'icons/X.icon';

import './EnquiryContextTag.styles.scss';

type EnquiryContextTagProps = {
  className?: string;
  tag: string;
  isActive?: boolean;
  onClick?: () => void;
};

const EnquiryContextTag: React.FC<EnquiryContextTagProps> = (props) => {
  const { className, tag, isActive, onClick } = props;

  const classes = classNames(
    'enquiry-context-tag',
    { active: isActive, clickable: !!onClick },
    className,
  );

  return (
    <div className={classes} onClick={onClick}>
      {tag}
      {isActive && onClick && <Button variant="icon" icon={XIcon} />}
    </div>
  );
};

export default EnquiryContextTag;
